import React from 'react'
import { Form } from 'react-bootstrap'


function InputSizes() {
  return (
    <>
    <Form.Group className='form-group'>
        <label>Large input</label>
        <Form.Control type='text' placeholder='Username' aria-label='Username' size='lg'/>
    </Form.Group>
    <Form.Group className='form-group'>
        <label>Default input</label>
        <Form.Control type='text' placeholder='Username' aria-label='Username'/>
    </Form.Group>
    <Form.Group className='form-group'>
        <label>Smalll input</label>
        <Form.Control type='text' placeholder='Username' aria-label='Username' size='sm'/>
    </Form.Group>
    </>

  )
}

export default InputSizes